import React, { useEffect, useState } from 'react';
import { Button, Checkbox, FormControlLabel, Radio, RadioGroup, TextField, Grid, Box, Stack, Typography } from '@mui/material';
import { useSelector, useDispatch } from 'react-redux';
import { setData, setDataState } from '../redux/annotationSlice';
import { setImages, setImageMeta } from '../redux/imageSlice';
import ManAnnotateDialog from './dialogs/ManAnnotateDialog';
import InfoDialog from './dialogs/InfoDialog';
import axios from 'axios';
import { API_URL } from '../config/endpoint';
import useSnackbar from './dialogs/Snackbar';
import LoadPattern from './dialogs/LoadPattern';


function AnnotationForm() {
    const [SnackbarComponent, showSnackbar] = useSnackbar();
    const {
        octMaia, fullETDRS, tmmETDRS, squareGrid, degCircle, selectedEye, gridName
    } = useSelector(state => state.annotations);
    const { centerPoint, uuid, cns_annotations, maia_tgz_file, spectralis_high_res, etdrs } = useSelector(state => state.images)
    const [loading, setLoading] = useState(false)
    const [downloadLinks, setDownloadLinks] = useState(null)
    const dispatch = useDispatch();

    const handleSelectionChange = (event) => {
        dispatch(setData({ name: event.target.name, checked: event.target.checked }));
    };

    const handleChange = (event) => {
        dispatch(setData({ name: event.target.name, checked: event.target.value }));
    };

    const bs_check = {
        fullETDRS: false, tmmETDRS: false, squareGrid: false, degCircle: false
    }


    // useEffect(() => {
    //     // Setting the OCT/ Maia IR Image checkbox to checked when the component mounts
    //     dispatch(setData({ name: 'octMaia', checked: true }));
    // }, [dispatch]);

    // useEffect(() => {
    //     if (!octMaia) {
    //         // Logic to trigger "MAIA TGZ File" upload
    //         const tgzFileInput = document.getElementById('upload-button-file-maia_tgz_file');
    //         if (tgzFileInput) {
    //             tgzFileInput.click();
    //         }
    //     }
    // }, [octMaia]);


    const handleCheckChange = (e) => {
        const { name, checked } = e.target
        var copy = { ...bs_check }
        delete copy[name]
        dispatch(setDataState({
            [name]: checked, ...copy
        }))
    }

    const onSaveClick = () => {
        setDownloadLinks(null)
        setLoading(true)
        const data_to_send = {
            eye: selectedEye, uuid: uuid, measurements: cns_annotations, maia_list: maia_tgz_file.options,
            zip_name: maia_tgz_file.zip_name, gridName: gridName, spectralis_high_res: spectralis_high_res.path,
            maia_tgz_image: maia_tgz_file.selectedOption.path,
            annotations: {
                fullETDRS, squareGrid, tmmETDRS, degCircle, etdrs
            },
            centerPoint: centerPoint
        }
        axios.post(`${API_URL}/save-points`, data_to_send, {
            headers: {
                'Content-Type': 'application/json'
            }
        }).then(res => {
            setDownloadLinks(res.data)
            setLoading(false)
        }).catch(err => {

            setLoading(false)
            if (err?.response?.status === 400) {
                showSnackbar(err.response.data, "error")
            } else {

                showSnackbar("Error saving points", "error")
            }
        })
    };

    async function downloadFileFromUrl(url, fileType) {
        try {
          const response = await fetch(url);
          const data = await response.blob();
      
          const fileName = gridName + "_" + selectedEye + "_" + url.substring(url.lastIndexOf('/') + 1);
          const blob = new Blob([data], { type: fileType });
          const blobUrl = URL.createObjectURL(blob);
      
          const a = document.createElement('a');
          a.href = blobUrl;
          a.download = fileName;
          a.style.display = 'none';
      
          document.body.appendChild(a);
          a.click();
      
          // Cleanup
          document.body.removeChild(a);
          URL.revokeObjectURL(blobUrl);
        } catch (error) {
          console.error('Error downloading file:', error);
        }
      }
      

    const downloadList = (images) => {
        images.map(img => {
            downloadFileFromUrl(img)
        })
    }




    return (
        <div className="annotation-form">
            <SnackbarComponent />
            <Stack spacing={1} direction={"row"} sx={{ py: 0.5 }}>
                <InfoDialog />
                <ManAnnotateDialog />
                {/* <Button variant="outlined" size="small" sx={{ textTransform: 'inherit' }}>Load Pattern</Button> */}
                <LoadPattern disabled={centerPoint === null} />
            </Stack>

            <Grid container spacing={2}>
                <Grid item md={7}>

                    <Box>
                        <FormControlLabel
                            control={<Checkbox checked={octMaia} onChange={handleSelectionChange} name="octMaia" />}
                            label={<div className="smallLabel">Switch OCT/MAIA Image</div>}
                        />
                        <FormControlLabel
                            control={<Checkbox checked={fullETDRS} disabled={centerPoint === null} onChange={handleCheckChange} name="fullETDRS" />}
                            label={<div className="smallLabel">Full ETDRS Grid</div>}
                        />
                        <FormControlLabel
                            control={<Checkbox checked={tmmETDRS} disabled={centerPoint === null} onChange={handleCheckChange} name="tmmETDRS" />}
                            label={<div className="smallLabel">1mm ETDRS Grid</div>}
                        />
                        <FormControlLabel
                            control={<Checkbox checked={squareGrid} disabled={centerPoint === null} onChange={handleCheckChange} name="squareGrid" />}
                            label={<div className="smallLabel">Square Grid</div>}
                        />
                        <FormControlLabel
                            control={<Checkbox checked={degCircle} disabled={centerPoint === null} onChange={handleCheckChange} name="degCircle" />}
                            label={<div className="smallLabel">30deg Circle</div>}
                        />
                    </Box>
                </Grid>

                <Grid item md={5}>
                    <Box sx={{ border: "1px solid #ccc", p: 0.5, borderRadius: "5px" }}>
                        <Typography>Select Eye</Typography>
                        <RadioGroup name="selectedEye" value={selectedEye} onChange={handleChange}>
                            <FormControlLabel value="left" control={<Radio />} label={`Left`} />
                            <FormControlLabel value="right" control={<Radio />} label={`Right`} />
                        </RadioGroup>
                    </Box>
                    <Box className="grid-name">
                        <TextField variant="outlined" name="gridName" label="Grid Name" value={gridName} size="small" onChange={handleChange} style={{ width: '100%' }} />
                    </Box>
                </Grid>
            </Grid>

            <Box style={{ my: 1, display: 'flex' }}>
                <Box sx={{ minWidth: '130px' }}>
                    <Button sx={{ textTransform: 'inherit' }} variant="contained" onClick={onSaveClick} disabled={loading} color="primary">Save Files</Button>
                </Box>
                {
                    downloadLinks &&
                    <Box>
                        <Grid container spacing={1} columns={2}>
                            <Grid item md={1} sx={{ justifyContent: 'center', display: 'flex' }}>
                                <Button
                                 sx={{ textTransform: 'inherit' }} 
                                    href={downloadLinks.tgz} size="small" variant="contained" color='success' download target="_blank">
                                    Download TGZ
                                </Button>
                            </Grid>
                            <Grid item md={1} sx={{ justifyContent: 'center', display: 'flex' }}>
                                <Button sx={{ textTransform: 'inherit' }} 
                                    onClick={() => downloadFileFromUrl(downloadLinks.xml, 'application/xml')} size="small" variant="contained" color='success'>
                                    Download XML
                                </Button>
                            </Grid>
                            <Grid item md={1} sx={{ justifyContent: 'center', display: 'flex' }}>
                                <Button sx={{ textTransform: 'inherit' }} 
                                    onClick={() => downloadFileFromUrl(downloadLinks.json, 'application/json')} size="small" variant="contained" color='success'>
                                    Download JSON
                                </Button>
                            </Grid>
                            <Grid item md={1} sx={{ justifyContent: 'center', display: 'flex' }}>
                                <Button sx={{ textTransform: 'inherit' }} 
                                    onClick={() => downloadList(downloadLinks.images)} size="small" variant="contained" color='success'>
                                    Download PNG
                                </Button>
                            </Grid>
                        </Grid>
                    </Box>
                    
                }
                    </Box>
            
        </div>
    );
}

export default AnnotationForm;
